import {combine} from 'effector';
import {createGate} from 'effector-react';

import {
    clearWarehouseGridCache,
    fetchStorageLocations,
    fetchVirtualWarehouseGrid,
    fetchVirtualWarehouseGridUngrouped,
    loadGridCsv,
} from 'api';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {VirtualWarehouseGridAccessors, VirtualWarehouseGridRawRow} from 'types';
import {SimplePaginationContent} from 'types/api';
import {getFirstDayOfMonth} from 'utils/date';

const domain = rootDomain.createDomain('virtualWarehouseGridTableDomain');

export const CommonGate = createGate();
export const UngroupedGate = createGate();

export const fetchDataFx = domain.createEffect({
    name: 'fetchWarehouseGridFx',
    handler: fetchVirtualWarehouseGrid,
});

export const fetchDataUngroupedFx = domain.createEffect({
    name: 'fetchWarehouseGridUngroupedFx',
    handler: fetchVirtualWarehouseGridUngrouped,
});

export const clearDataCacheFx = domain.createEffect({
    name: 'clearDataCacheFx',
    handler: clearWarehouseGridCache,
});

export const fetchCsv = domain.createEffect({
    name: 'fetchWarehouseCsv',
    handler: loadGridCsv,
});

export const fetchStorageLocationsFx = domain.createEffect({
    name: 'fetchStorageLocationsFx',
    handler: fetchStorageLocations,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({
    domain,
});

export const data$ = domain.createStore<SimplePaginationContent<VirtualWarehouseGridRawRow> | null>(
    null,
);

export const dataUngrouped$ = domain.createStore<
    (SimplePaginationContent<VirtualWarehouseGridRawRow> & {totalCount: number}) | null
>(null);

// export const gtinCollapsedChanged = domain.createEvent<boolean>();
// export const gtinCollapsed$ = domain
//     .createStore<boolean>(false)
//     .on(gtinCollapsedChanged, (_, value) => value);

export const gridCacheChanged = domain.createEvent<{pageNumber: number; token: string | null}>();
export const gridCacheReset = domain.createEvent();
export const gridTokensCache$ = domain.createStore<Record<number, string | null>>({0: null});

export const storageLocationsNames$ = domain.createStore<
    {id: string; value: string; label: string}[]
>([]);
export const storageLocationsAddresses$ = domain.createStore<
    {id: string; value: string; label: string}[]
>([]);

export const tableState$ = combine({
    data: data$,
    dataUngrouped: dataUngrouped$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    // gtinCollapsed: gtinCollapsed$,
    dataLoading: fetchDataFx.pending,
    dataUngroupedLoading: fetchDataUngroupedFx.pending,
    exportPending: fetchCsv.pending,
});
